<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <div class="row">
            <div class="col-12 mb-4">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">{{ isEdicao ? 'Editar Atributo' : 'Novo Atributo' }}</h1>
                        <p class="welcome-message">
                            <button mat-icon-button (click)="voltar()">
                                <mat-icon>arrow_back</mat-icon>
                            </button>
                            Preencha os dados abaixo para {{ isEdicao ? 'editar' : 'cadastrar' }} o atributo.
                        </p>
                    </div>
                </div>
            </div>

            @if(isLoading) {
            <div class="col-12">
                <app-loading-box height="200"></app-loading-box>
            </div>
            } @else {
            <div class="col-12">
                <form [formGroup]="form">
                    <div class="row">
                        <div class="col-md-6">
                            <mat-form-field appearance="outline">
                                <mat-label>Nome do Atributo</mat-label>
                                <input matInput formControlName="nome" placeholder="Ex: Cor, Material" required>
                                @if (form.get('nome')?.hasError('required')) {
                                <mat-error>O nome é <strong>obrigatório</strong></mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field appearance="outline">
                                <mat-label>Campo Equivalente</mat-label>
                                <mat-select formControlName="idCampoEquivalenteAtributo">
                                    <mat-option [value]="null">Nenhum</mat-option>
                                    @for (item of listaCampoEquivalente; track item.id) {
                                    <mat-option [value]="item.id">{{ item.descricao }}</mat-option>
                                    }
                                </mat-select>
                                <mat-hint>Opcional: Selecione um campo equivalente se houver.</mat-hint>
                            </mat-form-field>
                        </div>
                    </div>
                </form>
            </div>
            }
        </div>
    </div>
</div>

<app-footer-action [isLoadingSalvar]="isSaving" [isSalvarDisabled]="isLoading" (cancelar)="voltar()"
    (salvar)="salvar()"></app-footer-action>